import {Visibility,Autorenew} from "@mui/icons-material";
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import BlueskyIcon from "./BlueskyIcon";
import { Box, Divider } from "@mui/material";
import React from "react";
import { parseTwitterHashtag, parseURL, prettyTruncate } from "../../../common";
import PostDateElement from "../element/PostDateElement";
import PostMetaElement from "../element/PostMetaElement";
import PostTextElement from "../element/PostTextElement";
import PostTitleElement from "../element/PostTitleElement";

function BlueskyPostCard({post, padding, intent}){
    
    let text = post.post_text;
    text = parseURL(text);
    // text = parseTwitterUsername(text);
    text = parseTwitterHashtag(text);
    
    const title = "@" + post.user_screenname;
    return <>
        <Box p={padding}>
            <PostTitleElement title={title} link={"https://t.me/" + post.user_screenname} />
        </Box>
        {post.img && <img alt={title} src={post.img} style={{maxWidth: '100%'}}/>}
        <Box p={padding}>
            <PostTextElement post={post} text={prettyTruncate(text,300)} intent={intent} />

            <PostDateElement post={post} />
        </Box>
        <Divider />
        <Box p={padding} display="flex" alignItems={"center"} justifyContent="space-between">
            <Box display="flex" alignItems={"center"} mr={1}>
                <FavoriteBorderOutlinedIcon sx={{color: '#666666', marginRight: 0.5}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_likes}</span>
                <Autorenew sx={{color: '#666666', marginRight: 0.5, marginLeft:0.5}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_shares}</span>
                <ChatBubbleOutlineOutlinedIcon sx={{color: '#666666', marginRight: 0.5, marginLeft:0.5}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_comments}</span>
            </Box>
            <BlueskyIcon sx={{color: '#0088cc'}}/>
        </Box>
        <Divider />
        <Box p={padding}>
            <PostMetaElement post={post} intent={intent} />
        </Box>
    </>
}
export default BlueskyPostCard;